/**
 * Main JavaScript for 2D Imaging, Inc. Website
 */

document.addEventListener('DOMContentLoaded', function() {
    // Mobile menu toggle
    const menuBtn = document.querySelector('.mobile-menu-btn');
    const navLinks = document.querySelector('.nav-links');
    
    if (menuBtn) {
        menuBtn.addEventListener('click', function() {
            navLinks.classList.toggle('active');
        });
    }
    
    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.mobile-menu-btn') && !e.target.closest('.nav-links')) {
            navLinks?.classList.remove('active');
        }
    });
    
    // Pages without a contact section send Contact links to the homepage's
    if (!document.getElementById('contact')) {
        document.querySelectorAll('a[href="#contact"]').forEach(link => link.setAttribute('href', '/#contact'));
    }

    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;
            
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                e.preventDefault();
                
                // Close mobile menu if open
                navLinks?.classList.remove('active');
                
                // Smooth scroll to target
                targetElement.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });
    
    // Setup scroll events
    window.addEventListener('scroll', function() {
        toggleStickyHeader();
        setActiveNavItem();
        checkAnimateElements();
    });
    
    // Initialize features
    toggleStickyHeader();
    setActiveNavItem();
    checkAnimateElements();
    setupFormListeners();
});

/**
 * Make header sticky when scrolling down
 */
function toggleStickyHeader() {
    const header = document.querySelector('header');
    if (!header) return;
    
    if (window.scrollY > 50) {
        header.classList.add('sticky');
    } else {
        header.classList.remove('sticky');
    }
}

/**
 * Set active navigation item based on scroll position
 */
function setActiveNavItem() {
    const sections = document.querySelectorAll('section[id]');
    const navLinks = document.querySelectorAll('.nav-links a');
    
    if (!sections.length || !navLinks.length) return;
    
    const scrollPosition = window.scrollY + 100;
    
    sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute('id');
        
        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
            navLinks.forEach(link => {
                link.classList.remove('active');
                if (link.getAttribute('href') === '#' + sectionId) {
                    link.classList.add('active');
                }
            });
        }
    });
}

/**
 * Animate elements when they come into view
 */
function checkAnimateElements() {
    const animateElements = document.querySelectorAll('.animate');
    
    if (!animateElements.length) return;
    
    animateElements.forEach(element => {
        const elementPosition = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        
        if (elementPosition < windowHeight - 100) {
            element.classList.add('animated');
        }
    });
}

/**
 * Set up form validation and submission handlers
 */
function setupFormListeners() {
    const forms = document.querySelectorAll('#contact-form, #application-form');
    
    if (!forms.length) return;
    
    forms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            // Basic validation - could be expanded
            let isValid = true;
            const requiredInputs = form.querySelectorAll('[required]');
            
            requiredInputs.forEach(input => {
                if (!input.value.trim()) {
                    input.classList.add('form__input--error');
                    isValid = false;
                } else {
                    input.classList.remove('form__input--error');
                }
            });
            
            const status = form.querySelector('.form__status');
            const fileInput = form.querySelector('input[type="file"]');
            const file = fileInput && fileInput.files[0];

            // Netlify rejects requests over 8 MB
            if (isValid && file && file.size > 7.5 * 1024 * 1024) {
                fileInput.classList.add('form__input--error');
                status.textContent = 'That file is too large. Please attach a file under 7.5 MB, or email your resume to support@2dimaging.com.';
                isValid = false;
            }

            if (isValid) {
                const button = form.querySelector('[type="submit"]');
                button.disabled = true;
                button.textContent = 'Sending...';

                // The form posts to the Netlify form service (FORM_ENDPOINT), which emails the submission
                const position = form.elements.position;
                form.elements.subject.value = position && !position.disabled
                    ? 'Careers application: ' + position.value
                    : 'Website inquiry: ' + form.elements.inquiry.value;
                form.submit();
            }
        });

        // Remove error state on input
        const inputs = form.querySelectorAll('.form__input');
        inputs.forEach(input => {
            input.addEventListener('input', function() {
                if (this.value.trim()) {
                    this.classList.remove('form__input--error');
                }
            });
        });
    });
} 